import React from 'react';
import { TextField } from '@mui/material';
import { CommonTextAreaProps } from '../types/common.types';

const CommonTextArea: React.FC<CommonTextAreaProps> = ({
  name,
  label,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  error = false,
  helperText,
  fullWidth = true,
  minRows = 3,
  maxRows,
}) => {
  return (
    <TextField
      name={name}
      label={label}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      size="small"
      variant="outlined"
      multiline
      minRows={minRows}
      maxRows={maxRows}
      InputLabelProps={{ shrink: true }}
    />
  );
};

export default CommonTextArea;